import React, { Component } from 'react';
import MySelect from "../../../../../../components/CheckboxSelect";
import { postGamVerificationAction, postGoogleAccountsAction, postGamCampaignAction, postGamSyncCampaignAction, getUserInformationAction, createAdvertiserAction, getGamUrlAction } from "../../../../../../actions";  
import { connect } from 'react-redux';
import ReactSelect from "react-select";
import _, { isEmpty, get } from 'lodash';
import ToastModal from "../../../../../../components/ToastModal";
import routes from "../../../../../../routes";
import { withRouter } from 'react-router-dom';

class index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      gamAds: [{ optionSelected: [], status: false, masterAccounts: [], masterDisabled: false, accToggle: false, campaignToggle: false, fetchAccount: [], accountDisabled: false, campaignDetailsList: {}, campaignSelected: [] }],
      masterAccountToogle: false,
      accToggle: false,
      campaignToggle: false,
      masterAccounts: [],
      accountIds: [],
      cardStatus: false,
      fetchAccount: [],
      accountSelected: [],
      campaignDetails: {},
      campaignPayload: [],
      accountDisabled: false,
      masterDisabled: false,
      enableToast: false,
      toastStatus: "",
      toastMsg: "",
      confirmationMsg: "",
      res: [],
      campaignDetailsList: [],
    }
  }

  async componentWillMount() {
    const { path } = this.props;
    const { history, match } = path;

    if ((window.location.href != `${window.location.origin}/atd/admin/advertiser-list/add-advertiser`)) {
      localStorage.setItem("url", JSON.stringify(window.location.href));
      if (localStorage.getItem("url")) {
        history.push(`${match.path}`)
      }
    }

    setTimeout(() => {
      let url = JSON.parse(localStorage.getItem("url"));
      if (url && !url.includes("access_denied")) {
        this.handleVerification(url);
      } else {
        // localStorage.removeItem("loginClicked")
      }
    }, 1000)

    if (JSON.parse(localStorage.getItem("syncId"))) {
      this.handleCampaigns();
    }
  }

  // =========== get Google file url =============
  handleGenerateUrl = async (index) => {
    const { getGamUrlAction } = this.props;
    const { gamAds } = this.state;
    localStorage.setItem("loginClicked", JSON.stringify(true));
    let localUrl = localStorage.getItem("url");

    if (localUrl == null) {
      const { responseCode: { status = "" }, response: { platform, url } } = await getGamUrlAction();
      if (status == "Success") {
        gamAds.forEach(item => {
          item.status = true;
        })
        localStorage.setItem("gamAds", JSON.stringify(gamAds))
        window.location.href = url;
      }
    } else if (localUrl != null) {
      if (localUrl.includes("access_denied")) {
        const { responseCode: { status = "" }, response: { platform, url } } = await getGamUrlAction();
        if (status == "Success") {
          window.location.href = url;
        } else {
          localStorage.removeItem("advertiserPlatform");
          localStorage.removeItem("addType");
        }
      }
    }
  }

  // ======== google verification ========
  handleVerification = async (url) => {
    let payload = {
      url: url,
    }

    const { postGamVerificationAction } = this.props;
    const { responseCode: { status = "" }, responseList } = await postGamVerificationAction({
      payload
    });

    if (status == "Success") {
      localStorage.removeItem("url");
      const masterAccountList = responseList.map(mcc => {
        return { value: mcc.descriptiveName, label: mcc.descriptiveName, masterid: mcc.id, email: mcc.email, refreshToken: mcc.refreshToken, isMasterNew: mcc.isMasterNew }
      });

      this.setState({ masterAccounts: masterAccountList }, () => {
        this.selectedValue();
      });

    } else {
      localStorage.removeItem("url");
      localStorage.removeItem("advertiserPlatform");
      localStorage.removeItem("addType");
      localStorage.removeItem("loginClicked");
    }
  }

  selectedValue = () => {
    const { masterAccounts, gamAds } = this.state;
    var selectedGamAdsData = JSON.parse(localStorage.getItem("gamAds"));

    selectedGamAdsData.forEach(item => {
      if (item.masterAccounts.length === 0) {
        item.masterAccounts = masterAccounts;
      }
    })

    this.setState({ gamAds: selectedGamAdsData, masterAccounts: masterAccounts, masterAccountToogle: true });
  }

  // ========== remove google adwords account ========
  handleRemoveClick = index => {
    const { gamAds } = this.state;
    const list = [gamAds];
    list.splice(index, 1);
    this.setState({ gamAds: list });
  };

  // ========== add new google adwords account ========
  handleAddClick = () => {
    this.setState({ gamAds: [...this.state.gamAds, { optionSelected: [], status: false, masterAccounts: [], masterDisabled: false, accToggle: false, campaignToggle: false, fetchAccount: [], accountDisabled: false, campaignSelected: [] }] });
  };

  // ======== fetch all account =========
  handleFetchAccount = async (index) => {
    const { accountIds, gamAds } = this.state;
    const { postGoogleAccountsAction } = this.props;
    let payload = {
      clientCustomer: accountIds
    }

    if (accountIds.length > 0) {
      const { responseCode: { status = "" }, responseList } = await postGoogleAccountsAction({ payload });

      if (status === "Success") {
        let res = responseList.map(res => {
          return { customerId: res.customerId, masterId: res.masterId, manager: res.manager, label: res.descriptiveName, value: res.descriptiveName, currencyCode: res.currencyCode, isNew: res.isNew, isMasterNew: res.isMasterNew, refreshToken: res.refreshToken, email: res.email }
        })

        gamAds[index].masterDisabled = true;
        gamAds[index].accToggle = true;
        gamAds[index].fetchAccount = res;
        // gamAds[index].masterAccountToogle = true;


        this.setState({ accToggle: true })
      }
    } else {
      this.setState({ enableToast: true, confirmationMsg: "Please Select A Master Account.", toastMsg: "", toastStatus: "required" });
    }
  }

  // =========== btn toggle =========
  toggle = (event, index) => {
    const { id } = event.target;
    if (id == "master-account") {
      this.handleFetchAccount(index);
    } else if (id == "account-list") {
      this.handleCampaigns(index);
    } else if (id == "exit-screen") {
      this.handleSyncCampaign();
    } else {
      this.setState({ campaignToggle: false })
    }
  }

  // ========= campaign list ===========
  handleCampaigns = async (index) => {
    const { fetchAccount, accountSelected, gamAds } = this.state;
    const { postGamCampaignAction, loginStatus, googleEditData } = this.props;

    console.log("loginStatus", loginStatus);

    if (!loginStatus) {
      var payload = {
        clientCustomer: accountSelected
      }

      if (accountSelected.length > 0) {
        const { responseCode: { status = "" }, responseList } = await postGamCampaignAction({ payload });
        if (status == "Success") {
          this.setState({ res: responseList });

          let res = responseList[0].campaignDetails.map(camp => {
            return { label: camp.CampaignName, value: camp.CampaignName, name: camp.CampaignName, isActive: camp.isActive, isCampaignNew: camp.isCampaignNew }
          })

          let obj = {
            customerId: responseList[0].customerId, masterId: responseList[0].masterId, currencyCode: responseList[0].currencyCode, isNew: 0, isMasterNew: 0, refreshToken: responseList[0].refreshToken, email: responseList[0].email, campaignDetails: res
          }
          if (!loginStatus) {
            gamAds[index].campaignToggle = true;
            gamAds[index].accountDisabled = true;
          }

          gamAds[index].campaignDetailsList = obj;
          this.setState({ campaignDetails: obj })
        }
      } else {
        this.setState({ enableToast: true, confirmationMsg: "Please Select A Account.", toastMsg: "", toastStatus: "required" });
      }
    } else {
      let syncPayload = [];
      googleEditData.forEach((item, index) => {
        let obj = {
          masterId: item.masterAccountId,
          customerId: item.accountId,
          refreshToken: -1
        }

        syncPayload.push(obj);
        
        gamAds[index].status = true;
        gamAds[index].campaignToggle = true;
      })

      var payload = {
        clientCustomer: syncPayload
      }

      const { responseCode: { status = "" }, responseList } = await postGamCampaignAction({ payload });
      if (status == "Success") {
        this.setState({ res: responseList });

        // let res = responseList[0].campaignDetails.map(camp => {
        //   return { label: camp.CampaignName, value: camp.CampaignName, name: camp.CampaignName, isActive: camp.isActive, isCampaignNew: camp.isCampaignNew }
        // })

        // let obj = {
        //   customerId: responseList[0].customerId, masterId: responseList[0].masterId, currencyCode: responseList[0].currencyCode, isNew: 0, isMasterNew: 0, refreshToken: responseList[0].refreshToken, email: responseList[0].email, campaignDetails: res
        // }

        // gamAds[index].campaignDetailsList = obj;
        // this.setState({ campaignDetails: obj })
      }
    }
  }




  // ======= get information =========
  getAllData = async () => {
    const { getUserInformationAction, tenantId } = this.props;
    const { responseCode: { status = "" }, responseList } = await getUserInformationAction({ tenantId })
    if (status === "Success") {
      this.setState({ userInfo: responseList })
    }
  }


  // ========== sync campaign =======
  handleSyncCampaign = async () => {
    const { campaignDetails, campaignPayload, res, gamAds } = this.state;

    const { postGamSyncCampaignAction, tenantId, handleCallback } = this.props;
    console.log("campaign ", campaignPayload);
    campaignDetails.campaignDetails = campaignPayload;
    let payload = {
      clientCustomer: [campaignDetails]
    }

    if (campaignPayload.length > 0) {
      const { responseCode: { status = "", msg = "" } } = await postGamSyncCampaignAction({ payload, tenantId });
      if (status == "Success") {
        handleCallback(gamAds, "login");
        // handleGoogleFunc(res);
        // this.createAdvertiser(res);
      }
    } else {
      this.setState({ enableToast: true, confirmationMsg: "Please select a campaign.", toastMsg: "", toastStatus: "required" });
    }
  }


  // ========== onChange ========
  handleSelectChange = (selected, index, name, campaignDetails) => {
    if (name === "master-account") {
      let accountId = [];
      selected.isMasterNew = 0;

      let obj = {
        masterId: selected.masterid,
        isMasterNew: selected.isMasterNew,
        email: selected.email,
        refreshToken: selected.refreshToken
      }

      accountId.push(obj);

      const { gamAds } = this.state;
      gamAds[index].optionSelected = selected;
      this.setState({ gamAds, accountIds: accountId });

    } else if (name === "accounts") {
      let accounts = [];
      selected.isMasterNew = 0;
      selected.isNew = 0;

      let obj = { customerId: selected.customerId, masterId: selected.masterId, currencyCode: selected.currencyCode, isNew: selected.isNew, isMasterNew: selected.isMasterNew, refreshToken: selected.refreshToken, email: selected.email }

      accounts.push(obj);

      const { gamAds } = this.state;
      gamAds[index].accountSelected = selected;
      this.setState({ gamAds, accountSelected: accounts });

    } else if (name === "campaigns") {
      const { gamAds } = this.state;
      gamAds[index].campaignSelected = selected;
      this.setState({ gamAds });

      let changeSelectedData = selected.map(sel => {
        return { CampaignName: sel.name, isActive: 1, isCampaignNew: 0 }
      })

      this.setState({ campaignPayload: changeSelectedData })
    }
  };

  toast = (status, msg) => {
    this.setState({ enableToast: true, toastStatus: status, toastMsg: msg });
    return;
  }

  confirmationCallbackModel = () => {
    this.setState({ enableToast: false }, () => {
      this.createAdvertiser();
    });
  }

  handleToastStatus = (status) => {
    const { path: { history } } = this.props;
    this.setState({ enableToast: status });
  }


  // handle save details
  handleSubmit = () => {
    this.setState({ enableToast: true, confirmationMsg: "Kindly let us know if you'd like to save your changes." });
  }

  createAdvertiser = async (res) => {
    const { tenantId, authToken, userId, createAdvertiserAction, history, match, advertiserPayload } =
      this.props;
    const { form } = this.state;

    let finalData = res.map(item => {
      return { platform: "Google Adwords", accountList: [{ masterAccountId: item.masterId, accountId: item.customerId, currency: item.currencyCode, inex: 1 }] }
    })

    const {
      responseCode: { status = "", msg = "" },
      // responseList,
    } = await createAdvertiserAction({
      tenantId,
      authToken,
      userId,
      payload: {
        advertisersPlatforms: [{
          advertiser: JSON.parse(localStorage.getItem("advertiserId")),
          inex: 1,
          platforms: finalData
        }]
      },
    });

    if (status) {
      localStorage.removeItem("advertiserId");
      this.toast(status, msg);
    }
  }

  render() {
    const { options, path } = this.props;
    const { accToggle, campaignToggle, masterAccountToogle, masterAccounts, cardStatus, fetchAccount, campaignDetails, masterDisabled, accountDisabled, enableToast, toastStatus, toastMsg, confirmationMsg, campaignDetailsList, gamAds } = this.state;
    let Option = options.optionFun;
    let multiValue = options.multiValue;

    console.log("gamAds", gamAds);

    return (
      <>
        {
          enableToast && <ToastModal
            enableToast={enableToast}
            status={toastStatus}
            msg={toastMsg}
            path={routes.containers.admin + "/" + routes.admin.advertiser.newAdvertiser}
            idProps={path}
            handleConfirmation={this.confirmationCallbackModel}
            handleToastStatus={this.handleToastStatus}
            confirmationMsg={confirmationMsg}
            poc={true}
          />
        }

        <div className='mainCard text-left'>
          {
            gamAds.map((gamList, index) => (
              gamList.status ?
                <div className='row mb-4' key={index}>
                  <div className='col-md-11' style={{ padding: "25px" }}>
                    {
                      (masterAccountToogle) ?
                        <>
                          <h5>Master Account List :</h5>
                          <div className='platform'>
                            <ReactSelect
                              options={gamList.masterAccounts}
                              defaultValue={gamList.optionSelected}
                              className="selectBox"
                              onChange={(selected) => this.handleSelectChange(selected, index, "master-account")}
                              isDisabled={gamList.masterDisabled}
                            />
                            {
                              !gamList.accToggle &&
                              <div className='syncCampagin text-right'>
                                <button className='btn-add' id='master-account' onClick={(e) => this.toggle(e, index)}>Fetch Account</button>
                              </div>
                            }
                          </div>
                        </> : ""
                    }

                    {
                      (gamList.accToggle) ?
                        <>
                          <h5>Account List :</h5>
                          <div className='platform'>
                            <ReactSelect
                              options={gamList.fetchAccount}
                              onChange={(selected) => this.handleSelectChange(selected, index, "accounts")}
                              defaultValue={gamList.accountSelected}
                              className="selectBox"
                              isDisabled={gamList.accountDisabled}
                            />
                            {
                              !gamList.campaignToggle &&
                              <div className='syncCampagin text-right'>
                                <button className='btn-add' id='account-list' onClick={(e) => this.toggle(e, index)}>Sync Campaign</button>
                              </div>
                            }
                          </div>
                        </> : ""
                    }

                    {
                      gamList.campaignToggle ?
                        <>
                          <h5>Sync Campaign :</h5>
                          <div className='platform'>
                            <MySelect
                              options={gamList.campaignDetailsList.campaignDetails}
                              isMulti
                              closeMenuOnSelect={false}
                              hideSelectedOptions={false}
                              components={{ Option, multiValue }}
                              onChange={(selected) => this.handleSelectChange(selected, index, "campaigns", campaignDetails)}
                              allowSelectAll={true}
                              value={gamList.campaignSelected}
                              className="selectBox"
                            />
                            <div className='syncCampagin text-right'>
                              <button className='btn-add' id='exit-screen' onClick={() => this.handleSyncCampaign()}>Save Changes</button>
                            </div>
                          </div>
                        </> : ""
                    }

                  </div>
                  {/* <div className='col-md-1 d-flex align-items-center mt-3' >
                      
                    </div> */}
                </div> :
                <div className='loginBtnList'>
                  <button key={index} className="loginBtn loginBtn--google" onClick={() => this.handleGenerateUrl(index)}>
                    Login with Gam
                  </button>

                  <button className="btn-remove mr-4" onClick={() => this.handleRemoveClick(index)}><i className='mdi mdi-delete'></i></button>
                </div>
            ))
          }
        </div>

        <div className='addBtn' style={{ textAlign: "right" }}>
          <button className='btn-add-io' style={{ marginTop: "0px", float: "none" }} onClick={() => this.handleAddClick()}><i className="mdi mdi-plus-box"></i>
          </button>
        </div>

      </>
    )
  }
}

export default withRouter(connect(state => ({
  configurationList: get(state, 'app.configurationData.responseList', []),
  ioAdvertisersReport: get(state, 'app.ioAdvertisersReport.responseList', []),
  tenantId: get(state, 'app.preSignInState.tenantId', ''),
  userId: get(state, 'app.preSignInData.userId', ''),
  authToken: get(state, 'app.signInData.authToken', ''),
  responseAdvertiser: get(state, 'app.preSignInData.responseList', []),
}), { postGamVerificationAction, postGoogleAccountsAction, postGamCampaignAction, postGamSyncCampaignAction, getUserInformationAction, createAdvertiserAction, getGamUrlAction })(index));